import React, { useState } from 'react'
import ReactPaginate from 'react-paginate'
import { Button, InputGroup, Table } from 'react-bootstrap'
import SearchBox from '../../../components/Searchbox'
import { useEffect } from 'react'
import axiosProvider from '../../../lib/AxiosProvider'
import Loader from '../../../components/Loader'
import CustomToast from '../../../components/Toast/CustomToast'
import useDebounce from '../../../lib/useDebounce'
import { useSelector } from 'react-redux'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import EditIcon from '../../../components/AllSvgIcon/EditIcon'
import DeleteIcon from '../../../components/AllSvgIcon/DeleteIcon'
import { useLocation } from 'react-router-dom'
import { useImmer } from 'use-immer'
import Swal from 'sweetalert2'
import { _SwalDelete } from '../../../lib/exceptionMessage'
import { _percentageRegex_, _positiveInteger_ } from '../../../lib/Regex'
import {
  calculatePageRange,
  callApi,
  encodedSearchText,
  showToast
} from '../../../lib/AllGlobalFunction'
import { pageRangeDisplayed } from '../../../lib/AllStaticVariables'
import ExtraChargesForm from './ExtraChargesForm'

const ManageExtraCharges = () => {
  const initVal = {
    name: '',
    catID: null,
    chargesPaidByID: null,
    chargesIn: '',
    percentageValue: '',
    maxAmountValue: '',
    amountValue: ''
  }
  const [modalShow, setModalShow] = useState(false)
  const [data, setData] = useState()
  const [searchText, setSearchText] = useState()
  const debounceSearchText = useDebounce(searchText, 500)
  const [loading, setLoading] = useState(false)
  const { userId } = useSelector((state) => state?.user?.userInfo)
  const location = useLocation()
  const { pageAccess } = useSelector((state) => state.user)
  const [initialValues, setInitialValues] = useState(initVal)
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })
  const [allState, setAllState] = useImmer({
    category: [],
    chargesPaidBy: []
  })

  const [filterDetails, setFilterDetails] = useImmer({
    pageSize: 10,
    pageIndex: 1,
    searchText: ''
  })

  const handlePageClick = (event) => {
    setFilterDetails((draft) => {
      draft.pageIndex = event.selected + 1
    })
  }

  const fetchDataFromApis = async (endpoint, queryString, setterFunc) => {
    const response = await callApi(endpoint, queryString)
    return setterFunc(response)
  }

  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await axiosProvider({
        method: 'GET',
        endpoint: 'ExtraCharges/search',
        queryString: `?searchText=${encodedSearchText(
          filterDetails?.searchText
        )}&pageIndex=${filterDetails?.pageIndex}&pageSize=${
          filterDetails?.pageSize
        }`
      })

      setLoading(false)
      if (response?.status === 200) {
        setData(response)
      }
    } catch (error) {
      setLoading(false)
    }
  }

  const handleDelete = async (id) => {
    setLoading(true)
    try {
      const response = await axiosProvider({
        method: 'DELETE',
        endpoint: `ExtraCharges?id=${id}`,
        userId,
        location: location.pathname
      })

      if (response?.status === 200) {
        fetchData()
      }
      setLoading(false)
      showToast(toast, setToast, response)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (debounceSearchText) {
      setFilterDetails((draft) => {
        draft.searchText = debounceSearchText
        draft.pageIndex = 1
      })
    } else {
      setFilterDetails((draft) => {
        draft.searchText = ''
        draft.pageIndex = 1
      })
    }
  }, [debounceSearchText])

  useEffect(() => {
    fetchData()
  }, [filterDetails])

  return (
    <>
      <div className='d-flex align-items-center mb-3 gap-3 flex-row-reverse'>
        {checkPageAccess(
          pageAccess,
          allPages?.extraCharges,
          allCrudNames?.write
        ) && (
          <Button
            variant='warning'
            className='d-flex align-items-center gap-2 fw-semiboldd-flex align-items-center gap-2 fw-semibold btn btn-warning ms-auto btn btn-warning'
            onClick={() => {
              setModalShow(!modalShow)
              !allState?.chargesPaidBy?.length &&
                fetchDataFromApis(
                  'ChargesPaidBy/Search',
                  '?pageIndex=0&pageSize=0',
                  (data) => {
                    setAllState((draft) => {
                      draft.chargesPaidBy = data
                    })
                  }
                )

              !allState?.category?.length &&
                fetchDataFromApis(
                  'SubCategory/bindMainCategories',
                  '',
                  (data) => {
                    setAllState((draft) => {
                      draft.category = data
                    })
                  }
                )
            }}
          >
            <i className='m-icon m-icon--plusblack'></i>
            Create
          </Button>
        )}

        <div className='page-range'>
          {calculatePageRange({
            ...filterDetails,
            recordCount: data?.data?.pagination?.recordCount ?? 0
          })}
        </div>

        <div className='d-flex align-items-center'>
          <label className='me-1'>Show</label>
          <select
            name='dataget'
            className='form-select me-1'
            onChange={(e) => {
              setFilterDetails((draft) => {
                draft.pageSize = e?.target?.value
                draft.pageIndex = 1
              })
            }}
          >
            <option value='10'>10</option>
            <option value='25'>25</option>
            <option value='50'>50</option>
            <option value='100'>100</option>
            <option value='200'>200</option>
            <option value='500'>500</option>
          </select>
          entries
        </div>

        <SearchBox
          placeholderText={'Search'}
          searchclassnamewrapper={'searchbox-wrapper'}
          onChange={(e) => {
            setSearchText(e?.target?.value)
          }}
          value={searchText}
        />
      </div>

      <Table
        responsive
        hover
        className='align-middle table-list table'
        id='table'
      >
        <thead className='align-middle'>
          <tr>
            <th className='text-nowrap'>Charges Name</th>
            <th className='text-nowrap'>Charges on</th>
            <th className='text-nowrap'>Category Name</th>
            <th className='text-nowrap'>Charges in</th>
            <th className='text-nowrap'>Paid by</th>
            <th className='text-nowrap'>Value</th>
            <th className='text-nowrap'>Max.Value</th>
            <th className='text-nowrap text-center'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data?.data?.data?.length > 0 ? (
            data?.data?.data?.map((data, index) => (
              <tr key={data?.id}>
                <td>{data?.name}</td>
                <td>{data?.chargesOn}</td>
                <td>{data?.categoryName ? data?.categoryName : '-'}</td>
                <td>{data?.chargesIn}</td>
                <td>{data?.chargesPaidByName}</td>
                <td>{data?.amountValue}</td>
                <td>
                  {data?.chargesIn === 'Absolute' ? '-' : data?.maxAmountValue}
                </td>
                <td>
                  <div className='d-flex gap-2 justify-content-center align-items-center'>
                    {checkPageAccess(
                      pageAccess,
                      allPages?.extraCharges,
                      allCrudNames?.update
                    ) && (
                      <span
                        onClick={() => {
                          !allState?.chargesPaidBy?.length &&
                            fetchDataFromApis(
                              'ChargesPaidBy/search',
                              '?pageIndex=0&pageSize=0',
                              (data) => {
                                setAllState((draft) => {
                                  draft.chargesPaidBy = data
                                })
                              }
                            )
                          setModalShow(!modalShow)
                          setInitialValues(data)
                        }}
                      >
                        <EditIcon bg={'bg'} />
                      </span>
                    )}
                    {checkPageAccess(
                      pageAccess,
                      allPages?.extraCharges,
                      allCrudNames?.delete
                    ) && (
                      <span
                        onClick={() => {
                          Swal.fire({
                            title: _SwalDelete.title,
                            text: _SwalDelete.text,
                            icon: _SwalDelete.icon,
                            showCancelButton: _SwalDelete.showCancelButton,
                            confirmButtonColor: _SwalDelete.confirmButtonColor,
                            cancelButtonColor: _SwalDelete.cancelButtonColor,
                            confirmButtonText: _SwalDelete.confirmButtonText,
                            cancelButtonText: _SwalDelete.cancelButtonText
                          }).then((result) => {
                            if (result.isConfirmed) {
                              handleDelete(data?.id)
                            }
                          })
                        }}
                      >
                        <DeleteIcon bg={'bg'} />
                      </span>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8} className='text-center'>
                {data?.data?.message}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <ReactPaginate
        className='list-inline m-cst--pagination d-flex justify-content-end gap-1'
        breakLabel='...'
        nextLabel=''
        onPageChange={handlePageClick}
        pageRangeDisplayed={pageRangeDisplayed}
        pageCount={data?.data?.pagination?.pageCount ?? 0}
        previousLabel=''
        renderOnZeroPageCount={null}
        forcePage={filterDetails?.pageIndex - 1}
      />

      <ExtraChargesForm
        modalShow={modalShow}
        setModalShow={setModalShow}
        initialValues={initialValues}
        setInitialValues={setInitialValues}
        initVal={initVal}
        loading={loading}
        setLoading={setLoading}
        fetchData={fetchData}
        toast={toast}
        setToast={setToast}
        allState={allState}
      />

      {loading && !modalShow && <Loader />}

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}
    </>
  )
}

export default ManageExtraCharges
